"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APButton = _interopRequireDefault(require("../common/APButton"));
require("./AffiliateComponent.css");
var _clipboardHelper = _interopRequireDefault(require("../../helpers/clipboardHelper"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _AffiliateModalContainer = _interopRequireDefault(require("./AffiliateModalContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var affiliateClasses = (0, _cssClassesHelper.getBEMClasses)('affiliate');
var AffiliateActiveTag = function AffiliateActiveTag(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var route = props.route,
    affiliate = props.affiliate,
    showSnack = props.showSnack,
    openAffiliateModal = props.openAffiliateModal;
  var affiliateTag = "".concat(route).concat(affiliate.affiliateTag);
  var getModalButtonText = function getModalButtonText() {
    return affiliate.affiliateTag ? t("Edit") : t("Create");
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("section", {
    className: affiliateClasses('container-content')
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: affiliateClasses('tag')
  }, affiliate.affiliateTag), affiliate.affiliateTag && /*#__PURE__*/_react["default"].createElement("p", {
    id: "affiliateTag",
    className: affiliateClasses('tag-description')
  }, affiliateTag), /*#__PURE__*/_react["default"].createElement("div", {
    className: affiliateClasses('btn-container')
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    customClass: affiliateClasses(),
    onClick: function onClick() {
      return openAffiliateModal();
    }
  }, getModalButtonText()), affiliate.affiliateTag && /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    customClass: affiliateClasses(),
    onClick: function onClick() {
      showSnack(t("The affiliate tag has been copied to the clipboard."));
      (0, _clipboardHelper["default"])(affiliateTag);
    }
  }, t("Copy")))), /*#__PURE__*/_react["default"].createElement(_AffiliateModalContainer["default"], null));
};
AffiliateActiveTag.propTypes = {
  route: _propTypes["default"].string.isRequired,
  affiliate: _propTypes["default"].object.isRequired,
  showSnack: _propTypes["default"].func.isRequired,
  openAffiliateModal: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = AffiliateActiveTag;